export enum NotificationType {
  INFO,
  SUCCESS,
  ERROR,
}
